import {Pipe, PipeTransform} from '@angular/core';
import {ETipoCuestionario} from '@core/models';

@Pipe({name: 'obligatoriedad'})
export class ObligatoriedadPipe implements PipeTransform {
  transform(dato: number): any {
    
    // if (!dato) {
    //   return dato;
    // }

    
    switch (dato) {
      case 0:
        return 'OPCIONAL';
      case 1:
        return 'OBLIGATORIO';
      case 2:
        return 'VINCULADO';
      
      
    }
  }
}
